import React, { useContext, useEffect } from "react";

import Step1 from "./step";
import Step2 from "./step_medium";

import Header from "./header";

import App, { AppContext } from "./context";
import Comments from "./comments";

export default function Content() {
  const context = useContext(AppContext);

  useEffect(() => {
    const sidebar = document.getElementById("sidebar");
    if (!sidebar) return;

    if (context.index !== 0 && context.index !== context.workshop.steps.length + 1) {
      sidebar.style.display = "none";
    }
    return () => {
      sidebar.style.display = "block";
    };
  }, [context.index]);

  if (!context.workshop) return <div>Loading...</div>;
  if (context.index == 0 || context.index == context.workshop.steps.length + 1) return <div />;

  return (
    <div className="w-screen h-screen fixed inset-0 z-50 bg-[#FAFAFA] flex flex-col overflow-y-auto pb-[80px]">
      <Header />
      <div className="flex-1 px-4 sm:px-6 lg:px-8 pt-20 pb-8">
        <div className="max-w-5xl mx-auto">
          <div className="flex justify-between">{context.mode === "normal" ? <Step1 /> : <Step2 />}</div>
          <Comments />
        </div>
      </div>
    </div>
  );
}
